import React from "react";

export const Illustration4 = () => {
	return (
		<svg width={371} height={213} viewBox="0 0 371 213" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M40.3532 47.4544C-1.17703 121.914 -5.74829 174.745 24.6934 210.159H346.525C425.073 3.10996 291.317 41.7546 217.5 17.0471C143.683 -7.66038 73.3531 -11.7109 40.3532 47.4544Z"
				fill="#F5FAFF"
			/>
			<line x1={8.86562e-8} y1={210.799} x2={369} y2={210.799} stroke="#315C84" strokeWidth={2} />
			<path
				d="M59 107.288H219C221.209 107.288 223 109.079 223 111.288V210.8H55V111.288C55 109.079 56.7909 107.288 59 107.288Z"
				fill="#F9FCFF"
				stroke="#315C84"
				strokeWidth={2}
			/>
			<path
				d="M96.5 129.968C111.701 129.968 124 142.116 124 157.072C124 172.027 111.701 184.175 96.5 184.175C81.2989 184.175 69 172.027 69 157.072C69 142.116 81.2989 129.968 96.5 129.968Z"
				fill="#C4DBF1"
				fillOpacity={0.49}
				stroke="#315C84"
				strokeWidth={2}
			/>
			<mask id="path-5-inside-1_13119_626" fill="white">
				<path d="M96.5 128.968C112.24 128.968 125 141.55 125 157.072C125 167.021 119.756 175.762 111.846 180.756V172.476C111.846 167.44 108.124 163.275 103.28 162.579C106.465 160.439 108.557 156.835 108.558 152.748C108.558 146.182 103.159 140.858 96.5 140.858C89.8407 140.858 84.4424 146.182 84.4424 152.748C84.4425 156.835 86.5341 160.439 89.7188 162.579C84.8759 163.275 81.1544 167.44 81.1543 172.476V180.756C73.2438 175.762 68 167.021 68 157.072C68 141.55 80.7599 128.968 96.5 128.968Z" />
			</mask>
			<path
				d="M96.5 128.968C112.24 128.968 125 141.55 125 157.072C125 167.021 119.756 175.762 111.846 180.756V172.476C111.846 167.44 108.124 163.275 103.28 162.579C106.465 160.439 108.557 156.835 108.558 152.748C108.558 146.182 103.159 140.858 96.5 140.858C89.8407 140.858 84.4424 146.182 84.4424 152.748C84.4425 156.835 86.5341 160.439 89.7188 162.579C84.8759 163.275 81.1544 167.44 81.1543 172.476V180.756C73.2438 175.762 68 167.021 68 157.072C68 141.55 80.7599 128.968 96.5 128.968Z"
				fill="#F9FCFF"
			/>
			<path
				d="M125 157.072L127 157.072V157.072H125ZM111.846 180.756H109.846V184.384L112.913 182.447L111.846 180.756ZM111.846 172.476H113.846V172.476L111.846 172.476ZM103.28 162.579L102.165 160.919L97.8481 163.82L102.996 164.559L103.28 162.579ZM108.558 152.748L110.558 152.748V152.748H108.558ZM96.5 140.858V138.858H96.5L96.5 140.858ZM84.4424 152.748H82.4424V152.748L84.4424 152.748ZM89.7188 162.579L90.0033 164.559L95.1497 163.819L90.8343 160.919L89.7188 162.579ZM81.1543 172.476L79.1543 172.476V172.476H81.1543ZM81.1543 180.756L80.0866 182.447L83.1543 184.384V180.756H81.1543ZM68 157.072H66V157.072L68 157.072ZM96.5 128.968V130.968C111.162 130.968 123 142.681 123 157.072H125H127C127 140.42 113.318 126.968 96.5 126.968V128.968ZM125 157.072L123 157.072C123 166.298 118.14 174.417 110.778 179.065L111.846 180.756L112.913 182.447C121.372 177.107 127 167.744 127 157.072L125 157.072ZM111.846 180.756H113.846V172.476H111.846H109.846V180.756H111.846ZM111.846 172.476L113.846 172.476C113.846 166.431 109.378 161.435 103.565 160.6L103.28 162.579L102.996 164.559C106.869 165.115 109.846 168.449 109.846 172.476L111.846 172.476ZM103.28 162.579L104.396 164.239C108.103 161.749 110.557 157.538 110.558 152.748L108.558 152.748L106.558 152.748C106.557 156.133 104.828 159.13 102.165 160.919L103.28 162.579ZM108.558 152.748H110.558C110.558 145.051 104.238 138.858 96.5 138.858V140.858V142.858C102.081 142.858 106.558 147.312 106.558 152.748H108.558ZM96.5 140.858L96.5 138.858C88.7625 138.858 82.4424 145.051 82.4424 152.748H84.4424H86.4424C86.4424 147.312 90.919 142.858 96.5 142.858L96.5 140.858ZM84.4424 152.748L82.4424 152.748C82.4426 157.537 84.8963 161.748 88.6032 164.239L89.7188 162.579L90.8343 160.919C88.172 159.13 86.4425 156.133 86.4424 152.748L84.4424 152.748ZM89.7188 162.579L89.4342 160.6C83.6212 161.435 79.1544 166.431 79.1543 172.476L81.1543 172.476L83.1543 172.476C83.1544 168.449 86.1307 165.116 90.0033 164.559L89.7188 162.579ZM81.1543 172.476H79.1543V180.756H81.1543H83.1543V172.476H81.1543ZM81.1543 180.756L82.222 179.065C74.8599 174.417 70 166.298 70 157.072L68 157.072L66 157.072C66 167.744 71.6277 177.107 80.0866 182.447L81.1543 180.756ZM68 157.072H70C70 142.681 81.8379 130.968 96.5 130.968V128.968V126.968C79.6818 126.968 66 140.42 66 157.072H68Z"
				fill="#315C84"
				mask="url(#path-5-inside-1_13119_626)"
			/>
			<rect x={135} y={135.871} width={60} height={5.91653} fill="#C4DBF1" />
			<rect x={135} y={158.551} width={72} height={5.91653} fill="#C4DBF1" />
			<rect x={135} y={172.356} width={51} height={5.91653} fill="#C4DBF1" />
			<path
				d="M140 144.745L141.123 148.493H144.755L141.816 150.809L142.939 154.557L140 152.241L137.061 154.557L138.184 150.809L135.245 148.493H138.877L140 144.745Z"
				fill="#C4DBF1"
				fillOpacity={0.49}
			/>
			<path
				d="M153 144.745L154.123 148.493H157.755L154.816 150.809L155.939 154.557L153 152.241L150.061 154.557L151.184 150.809L148.245 148.493H151.877L153 144.745Z"
				fill="#C4DBF1"
				fillOpacity={0.49}
			/>
			<path
				d="M165.5 144.745L166.735 148.493H170.731L167.498 150.809L168.733 154.557L165.5 152.241L162.267 154.557L163.502 150.809L160.269 148.493H164.265L165.5 144.745Z"
				fill="#C4DBF1"
				fillOpacity={0.49}
			/>
			<path
				d="M178.5 144.745L179.735 148.493H183.731L180.498 150.809L181.733 154.557L178.5 152.241L175.267 154.557L176.502 150.809L173.269 148.493H177.265L178.5 144.745Z"
				fill="#C4DBF1"
				fillOpacity={0.49}
			/>
			<mask id="path-14-inside-2_13119_626" fill="white">
				<path d="M257 146.718L261.559 131.094H217C214.239 131.094 212 128.855 212 126.094V56.0671C212 53.3057 214.239 51.0671 217 51.0671H329C331.761 51.0671 334 53.3057 334 56.0671V126.094C334 128.855 331.761 131.094 329 131.094H283.503L257 146.718Z" />
			</mask>
			<path
				d="M257 146.718L261.559 131.094H217C214.239 131.094 212 128.855 212 126.094V56.0671C212 53.3057 214.239 51.0671 217 51.0671H329C331.761 51.0671 334 53.3057 334 56.0671V126.094C334 128.855 331.761 131.094 329 131.094H283.503L257 146.718Z"
				fill="#F9FCFF"
			/>
			<path
				d="M257 146.718L255.08 146.157L253.666 151.005L258.016 148.44L257 146.718ZM261.559 131.094L263.479 131.654L264.226 129.094H261.559V131.094ZM217 131.094L217 133.094H217V131.094ZM212 56.0671L210 56.0671V56.0671H212ZM329 51.0671V49.0671V51.0671ZM334 56.0671H336H334ZM283.503 131.094V129.094H282.957L282.487 129.371L283.503 131.094ZM257 146.718L258.92 147.278L263.479 131.654L261.559 131.094L259.639 130.533L255.08 146.157L257 146.718ZM261.559 131.094V129.094H217V131.094V133.094H261.559V131.094ZM217 131.094L217 129.094C215.343 129.094 214 127.75 214 126.094H212H210C210 129.959 213.134 133.094 217 133.094L217 131.094ZM212 126.094H214V56.0671H212H210V126.094H212ZM212 56.0671L214 56.0671C214 54.4103 215.343 53.0671 217 53.0671V51.0671V49.0671C213.134 49.0671 210 52.2011 210 56.0671L212 56.0671ZM217 51.0671V53.0671H329V51.0671V49.0671H217V51.0671ZM329 51.0671V53.0671C330.657 53.0671 332 54.4103 332 56.0671H334H336C336 52.2011 332.866 49.0671 329 49.0671V51.0671ZM334 56.0671H332V126.094H334H336V56.0671H334ZM334 126.094H332C332 127.75 330.657 129.094 329 129.094V131.094V133.094C332.866 133.094 336 129.959 336 126.094H334ZM329 131.094V129.094H283.503V131.094V133.094H329V131.094ZM283.503 131.094L282.487 129.371L255.984 144.995L257 146.718L258.016 148.44L284.519 132.816L283.503 131.094Z"
				fill="#315C84"
				mask="url(#path-14-inside-2_13119_626)"
			/>
			<rect x={255} y={74.7332} width={61} height={5.91653} fill="#C4DBF1" />
			<rect x={229} y={90.5106} width={87} height={5.91653} fill="#C4DBF1" />
			<rect x={229} y={106.288} width={79} height={5.91653} fill="#C4DBF1" />
			<path
				d="M93.546 18.3023C106.388 13.1481 121.019 19.2395 126.236 31.8802C131.454 44.5211 125.296 58.956 112.454 64.1102C99.6116 69.2643 84.981 63.1731 79.7634 50.5323C74.5459 37.8915 80.7041 23.4565 93.546 18.3023Z"
				fill="#F9FCFF"
				stroke="#315C84"
				strokeWidth={2}
			/>
			<path
				d="M114.492 31.2887C114.031 31.2475 107.068 34.2684 107.068 34.2684C107.048 33.1456 106.469 26.3675 104.226 25.2328C102.431 24.3249 100.94 25.8732 101.18 26.4552C101.42 27.0372 102.842 29.4064 102.621 29.9472C102.401 30.488 99.2626 37.401 100.143 39.535L105.428 52.3391L119.515 46.6852C120.59 44.9876 119.363 43.8067 118.615 43.4284C120.018 41.237 118.439 39.9561 117.474 39.5896C119.118 37.1207 117.038 35.8449 115.793 35.5155C117.284 33.1078 114.953 31.3299 114.492 31.2887Z"
				fill="#C4DBF1"
			/>
			<rect
				width={9.34707}
				height={17.1856}
				transform="matrix(0.928043 -0.372473 0.381535 0.924355 87.7186 40.9297)"
				fill="#C4DBF1"
			/>
			<path
				d="M314.426 153.736C324.666 157.985 329.461 169.606 325.161 179.683C320.861 189.759 309.083 194.504 298.842 190.255C288.602 186.006 283.808 174.384 288.108 164.308C292.408 154.232 304.186 149.487 314.426 153.736Z"
				fill="#F9FCFF"
				stroke="#315C84"
				strokeWidth={2}
			/>
			<path
				d="M318.959 172.797C318.719 172.514 312.984 170.318 312.984 170.318C313.623 169.664 317.221 165.459 316.595 163.545C316.094 162.014 314.343 162.06 314.143 162.528C313.943 162.997 313.384 165.154 312.944 165.339C312.504 165.524 306.701 167.711 305.968 169.429L301.571 179.735L312.909 184.44C314.508 184.074 314.49 182.706 314.282 182.068C316.355 181.605 316.194 179.982 315.854 179.229C318.226 178.742 317.775 176.84 317.254 175.949C319.503 175.412 319.199 173.081 318.959 172.797Z"
				fill="#C4DBF1"
			/>
			<rect
				width={7.55926}
				height={13.9018}
				transform="matrix(0.923646 0.383248 -0.392481 0.91976 298.05 163.224)"
				fill="#C4DBF1"
			/>
			<path
				d="M172.889 55.0907C181.769 58.7753 185.924 68.852 182.197 77.5865C178.469 86.3208 168.259 90.436 159.379 86.7515C150.499 83.0669 146.344 72.991 150.071 64.2566C153.798 55.5222 164.01 51.4064 172.889 55.0907Z"
				fill="#F9FCFF"
				stroke="#315C84"
				strokeWidth={2}
			/>
			<path
				d="M238 69.8167C242.432 69.8167 246 73.3557 246 77.6917C246 82.0275 242.431 85.5667 238 85.5667C233.569 85.5667 230 82.0275 230 77.6917C230 73.3557 233.568 69.8167 238 69.8167Z"
				fill="#C4DBF1"
				fillOpacity={0.49}
				stroke="#315C84"
				strokeWidth={2}
			/>
			<line
				y1={-1}
				x2={13.5719}
				y2={-1}
				transform="matrix(-0.884182 0.467142 -0.477423 -0.878674 269 155.592)"
				stroke="#315C84"
				strokeWidth={2}
			/>
			<line
				y1={-1}
				x2={7.24263}
				y2={-1}
				transform="matrix(-0.511002 0.85958 -0.865762 -0.500456 248.701 138.829)"
				stroke="#315C84"
				strokeWidth={2}
			/>
			<line
				y1={-1}
				x2={10.0485}
				y2={-1}
				transform="matrix(-0.995173 -0.0981328 0.100893 -0.994897 273 181.231)"
				stroke="#315C84"
				strokeWidth={2}
			/>
			<rect
				x={1.35089}
				y={0.444559}
				width={8.11719}
				height={18.0667}
				transform="matrix(0.895234 -0.445596 0.455658 0.890155 189.939 185.227)"
				fill="#F9FCFF"
				stroke="#315C84"
				strokeWidth={2}
			/>
			<path
				d="M259.157 189.964L209.565 196.373L201.069 179.776L235.751 144.238L259.157 189.964Z"
				fill="#F9FCFF"
				stroke="#315C84"
				strokeWidth={2}
			/>
			<line
				y1={-1}
				x2={25.1849}
				y2={-1}
				transform="matrix(-0.704996 0.709211 -0.719016 -0.694993 228.318 157.338)"
				stroke="#315C84"
				strokeWidth={2}
			/>
			<path
				d="M249.397 160.041L254.421 169.854L251.257 172.417L245.565 161.209L249.397 160.041Z"
				fill="#C4DBF1"
			/>
			<path
				d="M249.397 160.041L254.421 169.854L251.257 172.417L245.565 161.209L249.397 160.041Z"
				stroke="black"
			/>
			<line x1={24} y1={101.344} x2={34} y2={101.344} stroke="#315C84" strokeWidth={2} />
			<line x1={29} y1={96.4271} x2={29} y2={106.288} stroke="#315C84" strokeWidth={2} />
			<line x1={323} y1={40.2062} x2={333} y2={40.2062} stroke="#315C84" strokeWidth={2} />
			<line x1={328} y1={35.2897} x2={328} y2={45.1506} stroke="#315C84" strokeWidth={2} />
			<line x1={334} y1={149.662} x2={344} y2={149.662} stroke="#315C84" strokeWidth={2} />
			<line x1={339} y1={144.745} x2={339} y2={154.606} stroke="#315C84" strokeWidth={2} />
			<path
				d="M38.5 46.1506C40.9985 46.1506 43 48.1446 43 50.5745C42.9998 53.0042 40.9984 54.9973 38.5 54.9973C36.0016 54.9973 34.0002 53.0042 34 50.5745C34 48.1446 36.0015 46.1506 38.5 46.1506Z"
				stroke="#315C84"
				strokeWidth={2}
			/>
			<path
				d="M34 171.384C35.6701 171.384 37 172.715 37 174.328C37 175.941 35.6701 177.272 34 177.272C32.3299 177.272 31 175.941 31 174.328C31 172.715 32.3299 171.384 34 171.384Z"
				stroke="#315C84"
				strokeWidth={2}
			/>
			<path
				d="M354 126.024C356.222 126.024 358 127.797 358 129.954C358 132.112 356.222 133.885 354 133.885C351.778 133.885 350 132.112 350 129.954C350 127.797 351.778 126.024 354 126.024Z"
				fill="#E0EAF4"
				stroke="#315C84"
				strokeWidth={2}
			/>
			<path
				d="M120.5 83.6219C122.446 83.6219 124 85.1742 124 87.0594C124 88.9447 122.446 90.4969 120.5 90.4969C118.554 90.4969 117 88.9447 117 87.0594C117 85.1742 118.554 83.6219 120.5 83.6219Z"
				fill="#E0EAF4"
				stroke="#315C84"
				strokeWidth={2}
			/>
			<path
				d="M169.283 61.8588C166.232 60.9915 163.902 61.6402 161.719 63.3579C161.323 63.6695 161.253 64.231 161.562 64.6309L162.857 66.3102C163.168 66.714 163.752 66.8063 164.173 66.518C165.47 65.6287 166.376 65.1618 167.871 65.5869C169.047 65.9212 170.288 67.0674 169.965 68.1716C169.721 69.0063 168.884 69.2327 167.539 69.533C165.97 69.8831 163.91 70.2886 163.242 72.577L163.136 72.9393C162.992 73.4299 163.287 73.9444 163.793 74.0884L166.564 74.8758C167.07 75.0198 167.597 74.7389 167.741 74.2483L167.803 74.0346C168.267 72.4482 173.075 73.7432 174.33 69.4505C175.275 66.2177 172.528 62.781 169.283 61.8588ZM164.86 75.5724C163.4 75.1574 161.876 75.97 161.462 77.3837C161.049 78.7974 161.901 80.2851 163.361 80.7001C164.821 81.1152 166.345 80.3026 166.759 78.8889C167.172 77.4752 166.32 75.9874 164.86 75.5724Z"
				fill="#C4DBF1"
			/>
			<line
				y1={-1}
				x2={15.4926}
				y2={-1}
				transform="matrix(0.645469 0.763787 -0.772608 0.634883 197 29.3732)"
				stroke="#315C84"
				strokeWidth={2}
			/>
			<line
				y1={-1}
				x2={8.93}
				y2={-1}
				transform="matrix(-0.0694535 0.997585 -0.997716 -0.0675433 214.81 29.3564)"
				stroke="#315C84"
				strokeWidth={2}
			/>
			<line
				y1={-1}
				x2={8.52944}
				y2={-1}
				transform="matrix(0.937928 0.34683 -0.355455 0.934693 191 44.1646)"
				stroke="#315C84"
				strokeWidth={2}
			/>
		</svg>
	);
};
